import React, { useContext, useState, useEffect } from 'react';
import useApi from '../hooks/useApi';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import Modal from '../components/Modal';
import apiService from '../services/apiService';

const ExpertSlider = () => {
  const { data: users, isLoading, error } = useApi('/users/userRole/specialist');
  console.log("users******************",users)
  const [currentIndex, setCurrentIndex] = useState(0);
  const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';
  const navigate = useNavigate();
  const { isAuthenticated, user } = useContext(AuthContext);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isSubscriptionModalOpen, setIsSubscriptionModalOpen] = useState(false);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => Math.min(prevIndex + 1, users?.length - 1 || 0));
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  const [visibleSlides, setVisibleSlides] = useState(1);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) setVisibleSlides(4); // lg and above
      else if (window.innerWidth >= 640) setVisibleSlides(2); // md and above
      else setVisibleSlides(1); // sm and below
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const specialtyOptions = [
    { value: 'poultry_care', label: 'Poultry Care' },
    { value: 'cattle_health', label: 'Cattle Health' },
    { value: 'veterinary_surgery', label: 'Veterinary Surgery' },
    { value: 'animal_nutrition', label: 'Animal Nutrition' },
    { value: 'livestock_management', label: 'Livestock Management' },
    { value: 'disease_control', label: 'Disease Control' },
    { value: 'farm_vaccination', label: 'Farm Vaccination' },
    { value: 'poultry_diagnostics', label: 'Poultry Diagnostics' },
    { value: 'avian_diseases', label: 'Avian Diseases Specialist' },
    { value: 'hatchery_management', label: 'Hatchery Management' },
    { value: 'broiler_management', label: 'Broiler Management' },
    { value: 'layer_management', label: 'Layer Farm Management' },
    { value: 'biosecurity_management', label: 'Biosecurity Management' },
    { value: 'feed_formulation', label: 'Feed Formulation' },
    { value: 'parasite_control', label: 'Parasite Control' },
    { value: 'antibiotic_stewardship', label: 'Antibiotic Stewardship' },
    { value: 'reproductive_health', label: 'Reproductive Health' },
    { value: 'egg_quality_management', label: 'Egg Quality Management' },
    { value: 'farm_sanitation', label: 'Farm Sanitation & Hygiene' },
    { value: 'environmental_management', label: 'Poultry Environment Management' },
    { value: 'heat_stress_management', label: 'Heat Stress Management' },
    { value: 'poultry_welfare', label: 'Animal Welfare (Poultry)' },
    { value: 'veterinary_consultation', label: 'General Veterinary Consultation' },

  ];

  const getSpecialtyLabels = (specialties) => {
    return specialties.map((specialty) =>
      specialtyOptions.find((option) => option.value === specialty)?.label || specialty
    );
  };

  const formatRating = (rating) => {
    if (rating == null || isNaN(Number(rating))) return '4.67';
    return Number(rating).toFixed(2);
  };

  const handleBookNow = async (specialist) => {
    if (!isAuthenticated()) {
      setIsLoginModalOpen(true);
      return;
    }

    try {
      const subResponse = await apiService.get(`/stripe/subscription-status?userId=${user.id}`);
      if (!subResponse.data&&!subResponse.data.active) {
        setIsSubscriptionModalOpen(true);
      } else {
        navigate(`/book/${specialist._id}`, { state: { doctor: specialist } });
      }
    } catch (err) {
      console.error('Error checking subscription status:', err);
      setIsSubscriptionModalOpen(true);
    }
  };

  const handleLoginClose = () => {
    setIsLoginModalOpen(false);
    navigate('/login');
  };

  const handleSubscriptionClose = () => {
    setIsSubscriptionModalOpen(false);
  };

  const handleSubscriptionRedirect = () => {
    setIsSubscriptionModalOpen(false);
    navigate('/subscriptions');
  };

  if (isLoading) {
    return (
      <div className="text-center text-gray-600 text-lg font-medium py-12">
        Loading experts...
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center text-red-600 text-lg font-medium py-12">
        Error loading experts: {error.message}
      </div>
    );
  }

  const slideWidth = `${100 / visibleSlides}%`;

return (
 <div className="relative w-full max-w-7xl mx-auto py-12 sm:py-16 px-4 sm:px-6 lg:px-8">

    {/* Heading */}
    <div className="mb-10">
      <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-primary text-center tracking-tight">
        Our Highlighted Veterinary Doctors
      </h1>
      <div className="w-24 h-1 bg-secondary mx-auto mt-4 rounded-full"></div>
    </div>

    {/* ================= CAROUSEL WITH SIDE BUTTONS ================= */}
    <div className="relative">

      {/* Previous Button */}
      {users?.length > visibleSlides && (
        <button
          onClick={prevSlide}
          disabled={currentIndex === 0}
          className="absolute left-0 lg:-left-6 top-1/2 -translate-y-1/2 z-30 w-12 h-12 rounded-full bg-white shadow-xl border border-gray-200 text-gray-700 hover:bg-gray-50 transition-all duration-300 disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center"
        >
          ←
        </button>
      )}

      {/* Next Button */}
      {users?.length > visibleSlides && (
        <button
          onClick={nextSlide}
          disabled={currentIndex >= (users?.length - visibleSlides || 0)}
          className="absolute right-0 lg:-right-6 top-1/2 -translate-y-1/2 z-30 w-12 h-12 rounded-full bg-secondary text-white shadow-xl hover:bg-secondary/90 transition-all duration-300 disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center"
        >
          →
        </button>
      )}

      {/* Slider Track */}
      <div className="overflow-hidden">
        <div
          className="flex transition-transform duration-500 ease-in-out"
          style={{
            transform: `translateX(-${currentIndex * (100 / visibleSlides)}%)`,
          }}
        >
          {users?.map((user, index) => (
            <div
              key={index}
              className="p-3 flex-shrink-0"
              style={{ minWidth: slideWidth, maxWidth: slideWidth }}
            >
              {/* YOUR CARD */}
              <div className="group bg-white rounded-3xl border border-gray-100 shadow-sm hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 overflow-hidden flex flex-col h-full">

                {/* Image */}
                <div className="relative">
                  <img
                    src={
                      user.profilePicture
                        ? `${BASE_URL}${user.profilePicture}`
                        : "https://via.placeholder.com/500x500"
                    }
                    alt={user.name || "Veterinary Doctor"}
                    className="w-full h-64 sm:h-72 md:h-80 object-cover"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>

                  {/* Rating */}
                  <div className="absolute top-4 left-4 bg-white/95 px-3 py-1 rounded-full shadow-md text-sm font-semibold text-amber-500">
                    ★ {formatRating(user.rating)}
                  </div>

                  {/* Availability */}
                  <div
                    className={`absolute bottom-4 left-4 px-3 py-1 rounded-full text-xs sm:text-sm font-medium shadow-md ${
                      user.availability === "available"
                        ? "bg-emerald-600 text-white"
                        : "bg-red-600 text-white"
                    }`}
                  >
                    {user.availability === "available"
                      ? "● Available Now"
                      : "● Not Available"}
                  </div>

                  {/* Price */}
                  <div className="absolute bottom-4 right-4 bg-white/95 px-4 py-2 rounded-2xl shadow-lg">
                    <p className="text-xs text-gray-500">Starting From</p>
                    <p className="text-lg font-bold text-secondary">
                      £{user.fees != null ? Number(user.fees).toFixed(0) : "0"}
                    </p>
                  </div>
                </div>

                {/* Content */}
                <div className="p-5 sm:p-6 flex flex-col flex-1">
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 line-clamp-1">
                    {user.name || "Veterinary Doctor"}
                  </h3>

                  <p className="text-sm text-gray-500 mt-1 mb-4">
                    {user.experience != null
                      ? `${user.experience}+ years experience`
                      : "Experience not specified"}
                  </p>

                  <div className="flex flex-wrap gap-2 mb-6">
                    {getSpecialtyLabels(user.specialties || [])
                      .slice(0, 3)
                      .map((specialty, idx) => (
                        <span
                          key={idx}
                          className="bg-secondary/10 text-secondary text-xs font-semibold px-3 py-1 rounded-full"
                        >
                          {specialty}
                        </span>
                      ))}
                  </div>

                  <button
                    onClick={() => handleBookNow(user)}
                    disabled={user.availability !== "available"}
                    className="mt-auto w-full py-3.5 rounded-2xl bg-secondary text-white font-semibold hover:bg-secondary/90 transition"
                  >
                    Book Appointment
                  </button>
                </div>

              </div>
            </div>
          ))}
        </div>
      </div>
    </div>

    {/* Login Modal */}
    <Modal
      isOpen={isLoginModalOpen}
      onClose={handleLoginClose}
      title="Login Required"
    >
      <p className="text-gray-600 text-sm sm:text-base mb-4">
        Please log in to book an appointment with a veterinary specialist.
      </p>

      <button
        onClick={handleLoginClose}
        className="w-full bg-secondary text-white px-4 py-3 rounded-2xl hover:bg-secondary/90 transition font-semibold"
      >
        Go to Login
      </button>
    </Modal>

    {/* Subscription Modal */}
    <Modal
      isOpen={isSubscriptionModalOpen}
      onClose={handleSubscriptionClose}
      title="Subscription Required"
    >
      <p className="text-gray-600 text-sm sm:text-base mb-4">
        An active subscription is required to book an appointment.
        Please subscribe to continue.
      </p>

      <div className="flex justify-between gap-4">
        <button
          onClick={handleSubscriptionClose}
          className="flex-1 bg-gray-600 text-white px-4 py-3 rounded-2xl hover:bg-gray-700 transition font-semibold"
        >
          Cancel
        </button>

        <button
          onClick={handleSubscriptionRedirect}
          className="flex-1 bg-secondary text-white px-4 py-3 rounded-2xl hover:bg-secondary/90 transition font-semibold"
        >
          Subscribe Now
        </button>
      </div>
    </Modal>
  </div>
);
};

export default ExpertSlider;